import { Component, Input } from '@angular/core';

@Component({
	selector: 'nha-no-data-message',
	templateUrl: './no-data-message.component.html',
	styleUrls: ['./no-data-message.component.scss'],
	imports: []
})
export class NHANoDataMessageComponent {
	@Input() message: string;
}
